import React from "react";
import { StatusBadge } from "../../../../shared/components/badges/StatusBadge";
import { ExpandedAccordion } from "../../../../shared/components/ui/ExpandedAccordion";

const VaccineRecordExpandRow = ({ item }) => {
  const sections = [
    {
      id: "child",
      title: "Child Information",
      fields: [
        { label: "Child Name", value: item.child?.name || "—" },
        {
          label: "Date of Birth",
          value: item.child?.dateOfBirth
            ? new Date(item.child.dateOfBirth).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "—",
        },
        { label: "Gender", value: item.child?.gender || "—" },
        { label: "Parent Name", value: item.child?.parent?.fullName || "—" },
        { label: "Parent Phone", value: item.child?.parent?.phone || "—" },
        { label: "Parent Email", value: item.child?.parent?.email || "—" },
      ],
    },
    {
      id: "vaccination",
      title: "Vaccination Details",
      fields: [
        { label: "Vaccine Name", value: item.vaccine?.name || item.vaccineName || "—" },
        { label: "Vaccine Description", value: item.vaccine?.description || "—", isLong: true },
        { label: "Dosage", value: item.vaccine?.dosage || "—" },
        // { label: "Batch Number", value: item.batchNumber || "—" },
        { label: "Dose Label", value: item.doseLabel || `${item.doseNumber || "—"}` },
        { label: "Age at Vaccination", value: item.ageAtVaccination || "—" },
        {
          label: "Administered Date",
          value: item.administeredDate
            ? new Date(item.administeredDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
            : "—",
        },
        {
          label: "Next Due Date",
          value: item.nextDueDate
            ? new Date(item.nextDueDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "—",
        },
      ],
    },
    {
      id: "administration",
      title: "Administration Details",
      fields: [
        { label: "Administered By", value: item.administeredBy?.name || item.administeredBy?.fullName || "—" },
        { label: "Role", value: item.administeredBy?.role || "—" },
        { label: "Specialization", value: item.administeredBy?.specialization || "—" },
        { label: "Vaccination Center", value: item.vaccinationCenter?.name || "—" },
        { label: "Center Address", value: item.vaccinationCenter?.address || "—", isLong: true },
        { label: "Center Phone", value: item.vaccinationCenter?.phone || "—" },
        { label: "Completed by Medical Staff", value: item.completedByMedicalStaff ? "Yes" : "No" },
      ],
    },
    {
      id: "appointment",
      title: "Appointment Details",
      fields: [
        {
          label: "Scheduled Date",
          value: item.appointment?.scheduledDate
            ? new Date(item.appointment.scheduledDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "—",
        },
        { label: "Scheduled Time", value: item.appointment?.scheduledTime || "—" },
        { label: "Appointment Status", value: <StatusBadge status={item.appointment?.status || item.status} /> },
      ],
    },
    {
      id: "observations",
      title: "Observations & Notes",
      fields: [
        { label: "Reactions", value: item.reactions || "—", isLong: true },
        // { label: "Side Effects", value: item.sideEffects || "—", isLong: true },
        { label: "Additional Notes", value: item.notes || "—", isLong: true },
        {
          label: "Created At",
          value: item.createdAt
            ? new Date(item.createdAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
            : "—",
        },
        {
          label: "Updated At",
          value: item.updatedAt
            ? new Date(item.updatedAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
            : "—",
        },
      ],
    },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default VaccineRecordExpandRow;
